import fetch from "../../components/optionsFetch";
import DashboardChartCard, { DASHBOARD_CHART_OPTIONS, DashboardChartSkeleton, dashboardActionStyle as buttonStaticStyle } from "./DashboardChartCard";
import * as React from "react";
import ReactDOM from "react-dom";
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartTitle,
    ChartLegend,
    exportVisual,
    ChartSeriesDefaults,
} from "@progress/kendo-react-charts";
import configData from "../../config.json";
import { GetSession, GetToken } from "../../components/Session";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import { exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { GetCloudLogin } from "../../WeighBridge/Helpers";
import "hammerjs";
import { filterBy } from "@progress/kendo-data-query";





const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 10000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
    },
    content: {
        backgroundColor: "white",
        borderRadius: "8px",
        width: "95vw",
        height: "95vh",
        padding: "20px",
        position: "relative",
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        perspective: "1000px",
    },
    closeBtnTopRight: {
        position: "absolute",
        top: "10px",
        right: "15px",
        fontSize: "28px",
        border: "none",
        background: "none",
        cursor: "pointer",
        color: "#333",
    },
    closeBtnBottom: {
        marginTop: "auto",
        alignSelf: "center",
        padding: "10px 25px",
        fontSize: "16px",
        borderRadius: "5px",
        border: "1px solid #333",
        background: "white",
        cursor: "pointer",
        color: "#333",
        transition: "background-color 0.2s ease",
    },
};

const getFinancialYearDateRange = () => {
    const today = new Date();
    const financialYear = today.getMonth() >= 6 ? today.getFullYear() : today.getFullYear() - 1;
    const start = new Date(financialYear, 6, 1, 0, 0, 0, 0);
    const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

    return { start, end };
};

const getEndOfDay = (date) => {
    if (!date) return null;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
};

const getStartOfDay = (date) => {
    if (!date) return null;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
};

const PerformanceTrend = () => {
    const [panes, setPanes] = React.useState([{ size: "15%", collapsible: true }, {}]);
    const onChange = (event) => setPanes(event.newState);

    const [categories, setCategories] = React.useState(null);
    const [sales, setSales] = React.useState(null);
    const [productPerformance, setProductPerformance] = React.useState(null);
    const [pieData, setPieData] = React.useState(null);
    const [accumulated, setAccumulated] = React.useState(null);
    const [siteHeading, setSiteHeading] = React.useState("Site Performance");
    const [modalChart, setModalChart] = React.useState(null);

    const saleRef = React.useRef(null);
    const productRef = React.useRef(null);
    const totalRef = React.useRef(null);
    const siteRef = React.useRef(null);

    const [labels, setLabels] = React.useState(["1", "2"]);
    const [title, setTitle] = React.useState("");
    const [salesYAxis, setSalesYAxis] = React.useState("");
    const [productYAxis, setProductYAxis] = React.useState("");
    const [accYAxis, setAccYAxis] = React.useState("");
    const [expanded, setExpanded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    // Filter states
    const [loadTypes, setLoadTypes] = React.useState([]);
    const [loadType, setLoadType] = React.useState(JSON.parse(localStorage.getItem("DashboardLoadTypes")) || []);
    const [vehicleTypes, setVehicleTypes] = React.useState([]);
    const [vehicleType, setVehicleType] = React.useState(JSON.parse(localStorage.getItem("DashboardVehicleTypes")) || []);
    const [jobs, setJobs] = React.useState([]);
    const [job, setJob] = React.useState(JSON.parse(localStorage.getItem("DashboardJobs")) || []);
    const [customers, setCustomers] = React.useState([]);
    const [customer, setCustomer] = React.useState(JSON.parse(localStorage.getItem("DashboardCustomers")) || []);
    const [sources, setSources] = React.useState([]);
    const [source, setSource] = React.useState(JSON.parse(localStorage.getItem("DashboardSources")) || []);
    const [destinations, setDestinations] = React.useState([]);
    const [destination, setDestination] = React.useState(JSON.parse(localStorage.getItem("DashboardDestinations")) || []);
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState(JSON.parse(localStorage.getItem("DashboardSites")) || []);
    const [products, setProducts] = React.useState([]);
    const [product, setProduct] = React.useState(JSON.parse(localStorage.getItem("DashboardProducts")) || []);
    const [directions, setDirections] = React.useState([]);
    const [direction, setDirection] = React.useState(JSON.parse(localStorage.getItem("DashboardDirections")) || []);
    const [dateRange, setDateRange] = React.useState(getFinancialYearDateRange);
    const [productdata, setproductData] = React.useState();
    const [customerdata, setcustomerData] = React.useState();
    const [jobdata, setjobData] = React.useState();
    const [truckconfdata, settruckconfData] = React.useState();
    const [destdata, setdestData] = React.useState();
    const [srcdata, setsrcData] = React.useState();

    const onImageExportClick = React.useCallback((e) => {
        const chartName = e.currentTarget.name;
        let chartVisual = null;

        if (chartName === "sales") chartVisual = saleRef.current && exportVisual(saleRef.current);
        else if (chartName === "product") chartVisual = productRef.current && exportVisual(productRef.current);
        else if (chartName === "total") chartVisual = totalRef.current && exportVisual(totalRef.current);
        else chartVisual = siteRef.current && exportVisual(siteRef.current);

        if (chartVisual) {
            exportPDF(chartVisual, {
                paperSize: "A4",
                landscape: true,
            }).then((dataURI) => saveAs(dataURI, "Weekly Performance.pdf"));
        }
    }, []);

    const UpdateData = (
        lt = [],
        src = [],
        dest = [],
        st = [],
        jb = [],
        cust = [],
        prod = [],
        vt = [],
        dir = [],
        range = dateRange
    ) => {
        setIsLoading(true);
        const fromDate = getStartOfDay(range?.start) || getFinancialYearDateRange().start;
        const toDate = getEndOfDay(range?.end || range?.start) || getFinancialYearDateRange().end;
        const params = {
            FromDate: fromDate.toISOString(),
            ToDate: toDate.toISOString(),
            LoadType: lt.join(","),
            Source: src.map((v) => v.id).join(","),
            Destination: dest.map((v) => v.id).join(","),
            Site: st.map((v) => v.id).join(","),
            Job: jb.map((v) => v.id).join(","),
            Customer: cust.map((v) => v.id).join(","),
            Product: prod.map((v) => v.id).join(","),
            VehicleType: vt.map((v) => v.id).join(","),
            Direction: dir.join(","),
        };

        GetCloudLogin((cred) => {
            const token = cred === "" ? cred : cred.token;
            const sess = GetSession();
            let baseUrl = token && token !== "" ? sess.CloudURL : configData.SERVER_URL;
            const timeOffset = new Date().getTimezoneOffset() / 60;
            baseUrl += `apiV7/dashboard/getperformancetrends?prm=${encodeURI(
                JSON.stringify(params)
            )}&offset=${timeOffset}&siteId=${sess.SiteID}`;

            fetch(baseUrl, {
                method: "GET",
                accept: "application/json",
                headers: { Authorization: "Bearer " + (token || GetToken()) },
            })
                .then((response) => response.json())
                .then((d) => {
                    setSales(d.sales || []);
                    setProductPerformance(d.productPerformance || []);
                    setAccumulated(d.accumulated || []);
                    setPieData(d.pieData || []);
                    setCategories(d.productNames || []);
                    setLabels(d.labels || []);
                    setSiteHeading(d.sites === 1 ? "Product Share" : "Site Performance");
                    setTitle(d.title || "Sales Performance");
                    setSalesYAxis(d.salesY || "");
                    setProductYAxis(d.productY || "");
                    setAccYAxis(d.accY || "");
                })
                .catch(() => {
                    setSales([]);
                    setProductPerformance([]);
                    setAccumulated([]);
                    setPieData([]);
                    setCategories([]);
                    setLabels([]);
                })
                .finally(() => setIsLoading(false));
        });
    };

    React.useEffect(() => {
        UpdateData();

        fetch(configData.SERVER_URL + "apiv7/options", {
            method: "GET",
            accept: "application/json",
            headers: { Authorization: "Bearer " + GetToken() },
        })
                .then((response) => response.json())
                .then((d) => {
                setLoadTypes(d.loadTypes.filter((item) => item !== "First"));
                setVehicleTypes(d.vehicles);
                setJobs(d.jobs);
                setjobData(d.jobs);
                setCustomers(d.customers);
                setcustomerData(d.customers);
                setSources(d.sources);
                setsrcData(d.sources);
                setDestinations(d.destinations);
                setdestData(d.destinations);
                setSites(d.sites);
                setProducts(d.products);
                setproductData(d.products);
                setDirections(d.directions);
            });
    }, []);

    // Filter onChange handlers
    const changeHandlers = {
        loadType: (e) => {
            setLoadType(e.target.value);
            localStorage.setItem("DashboardLoadTypes", JSON.stringify(e.target.value));
        },
        vehicleType: (e) => {
            setVehicleType(e.target.value);
            localStorage.setItem("DashboardVehicleTypes", JSON.stringify(e.target.value));
        },
        job: (e) => {
            setJob(e.target.value);
            localStorage.setItem("DashboardJobs", JSON.stringify(e.target.value));
        },
        customer: (e) => {
            setCustomer(e.target.value);
            localStorage.setItem("DashboardCustomers", JSON.stringify(e.target.value));
        },
        source: (e) => {
            setSource(e.target.value);
            localStorage.setItem("DashboardSources", JSON.stringify(e.target.value));
        },
        destination: (e) => {
            setDestination(e.target.value);
            localStorage.setItem("DashboardDestinations", JSON.stringify(e.target.value));
        },
        site: (e) => {
            setSite(e.target.value);
            localStorage.setItem("DashboardSites", JSON.stringify(e.target.value));
        },
        product: (e) => {
            setProduct(e.target.value);
            localStorage.setItem("DashboardProducts", JSON.stringify(e.target.value));
        },
        direction: (e) => {
            setDirection(e.target.value);
            localStorage.setItem("DashboardDirections", JSON.stringify(e.target.value));
        },
    };

    const DoSearch = () => {
        UpdateData(loadType, source, destination, site, job, customer, product, vehicleType, direction, dateRange);
    };

    const ClearSearch = () => {
        const defaultDateRange = getFinancialYearDateRange();
        setLoadType([]);
        setVehicleType([]);
        setJob([]);
        setCustomer([]);
        setSource([]);
        setDestination([]);
        setSite([]);
        setProduct([]);
        setDirection([]);
        setDateRange(defaultDateRange);

        localStorage.setItem("DashboardLoadTypes", null);
        localStorage.setItem("DashboardVehicleTypes", null);
        localStorage.setItem("DashboardJobs", null);
        localStorage.setItem("DashboardCustomers", null);
        localStorage.setItem("DashboardSources", null);
        localStorage.setItem("DashboardDestinations", null);
        localStorage.setItem("DashboardSites", null);
        localStorage.setItem("DashboardProducts", null);
        localStorage.setItem("DashboardDirections", null);

        UpdateData([], [], [], [], [], [], [], [], [], defaultDateRange);
    };

    const DateRangeChanged = (event) => {
        const nextRange = {
            start: event.value?.start ? getStartOfDay(event.value.start) : dateRange.start,
            end: event.value?.end ? getEndOfDay(event.value.end) : event.value?.start ? getEndOfDay(event.value.start) : dateRange.end,
        };

        setDateRange(nextRange);
    };

    const ExportZoomButton = ({ name, onClick, iconClass, ariaLabel }) => (
        <button
            type="button"
            name={name}
            onClick={onClick}
            aria-label={ariaLabel}
            style={buttonStaticStyle}
            className="k-button k-button-icon"
        >
            <i className={`fa ${iconClass}`} aria-hidden="true" />
        </button>
    );

    const ButtonsGroup = ({ exportName, onExportClick, onZoomClick }) => (
        <div
            style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
                marginBottom: 8,
            }}
        >
            <ExportZoomButton
                name={exportName}
                onClick={onExportClick}
                iconClass="fa-download"
                ariaLabel="Export as PDF"
            />
            <ExportZoomButton
                onClick={onZoomClick}
                iconClass="fa-expand"
                ariaLabel="Expand Chart"
            />
        </div>
    );

    const filterproductData = (filter) => {
        const productdata = products.slice();
        return filterBy(productdata, filter);
    };
    const filterprodChange = (event) => {
        setproductData(filterproductData(event.filter));
    };

    const filterjobtData = (filter) => {
        const jobdata = jobs.slice();
        return filterBy(jobdata, filter);
    };
    const filterjobChange = (event) => {
        setjobData(filterjobtData(event.filter));
    };

    const filtercustomerData = (filter) => {
        const customerdata = customers.slice();
        return filterBy(customerdata, filter);
    };
    const filtercustChange = (event) => {
        setcustomerData(filtercustomerData(event.filter));
    };
    const filterdesData = (filter) => {
        const desdata = destinations.slice();
        return filterBy(desdata, filter);
    };
    const filterdestChange = (event) => {
        setdestData(filterdesData(event.filter));
    };

    const filtersrcData = (filter) => {
        const srcdata = sources.slice();
        return filterBy(srcdata, filter);
    };
    const filtersrcChange = (event) => {
        setsrcData(filtersrcData(event.filter));
    };


    const renderModalChart = () => {
        if (!modalChart) return null;

        const commonProps = {
            style: {
                height: "85vh",
                width: "100%",
                filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
                borderRadius: "10px",
            },
        };

        switch (modalChart) {
            case "sales":
                return (
                    <Chart {...DASHBOARD_CHART_OPTIONS} {...commonProps} ref={saleRef}>
                        <ChartTitle text={title} font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={labels || []} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: salesYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="line" />
                        <ChartSeries>
                            {(sales || []).map((item, idx) => (
                                <ChartSeriesItem
                                    key={idx}
                                    type="line"
                                    tooltip={{ visible: true }}
                                    data={item.data}
                                    name={item.name}
                                />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "product":
                return (
                    <Chart {...DASHBOARD_CHART_OPTIONS} {...commonProps} ref={productRef}>
                        <ChartTitle text="Product Performance (Top 5)" font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={categories || []} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: productYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="column" overlay={{ gradient: "sharpBevel" }} gap={0.3} spacing={0.2} />
                        <ChartSeries>
                            {(productPerformance || []).map((item, idx) => (
                                <ChartSeriesItem key={idx} data={item.data} name={item.name} />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "total":
                return (
                    <Chart {...DASHBOARD_CHART_OPTIONS} {...commonProps} ref={totalRef}>
                        <ChartTitle text="Accumulated Total" font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={labels || []} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: accYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="area" overlay={{ gradient: "sharpBevel" }} />
                        <ChartSeries>
                            {(accumulated || []).map((item, idx) => (
                                <ChartSeriesItem key={idx} data={item.data} name={item.name} />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "site":
                return (
                    <Chart {...DASHBOARD_CHART_OPTIONS} {...commonProps} ref={siteRef}>
                        <ChartTitle text={siteHeading} font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartSeries>
                            <ChartSeriesItem
                                type="pie"
                                overlay={{ gradient: "sharpBevel" }}
                                tooltip={{ visible: true }}
                                data={pieData || []}
                                categoryField="name"
                                field="share"
                            />
                        </ChartSeries>
                    </Chart>
                );
            default:
                return null;
        }
    };

    const dashboardCharts = React.useMemo(() => {
        const showSkeleton = isLoading;

        return (
            <>
                <div className="row mb-3">
                    <div className="col-6 mb-4">
                        <DashboardChartCard title={title || "Sales Performance"} icon="fa-chart-line" subtitle="Sales comparison over time" actions={<ButtonsGroup
                            exportName="sales"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("sales")}
                        />}>
                            {showSkeleton ? <DashboardChartSkeleton /> : (
                                <Chart {...DASHBOARD_CHART_OPTIONS} ref={saleRef} style={{ height: 245 }}>
                                    <ChartLegend position="top" orientation="horizontal" />
                                    <ChartCategoryAxis>
                                        <ChartCategoryAxisItem categories={labels || []} startAngle={45} />
                                    </ChartCategoryAxis>
                                    <ChartValueAxis>
                                        <ChartValueAxisItem title={{ text: salesYAxis }} />
                                    </ChartValueAxis>
                                    <ChartSeriesDefaults type="line" />
                                    <ChartSeries>
                                        {(sales || []).map((item, idx) => (
                                            <ChartSeriesItem key={idx} type="line" tooltip={{ visible: true }} data={item.data} name={item.name} />
                                        ))}
                                    </ChartSeries>
                                </Chart>
                            )}
                        </DashboardChartCard>
                    </div>

                    <div className="col-6 mb-4">
                        <DashboardChartCard title="Product Performance (Top 5)" icon="fa-cube" subtitle="Compare performance across products" actions={<ButtonsGroup
                            exportName="product"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("product")}
                        />}>
                            {showSkeleton ? <DashboardChartSkeleton /> : (
                                <Chart {...DASHBOARD_CHART_OPTIONS} ref={productRef} style={{ height: 245 }}>
                                    <ChartLegend position="top" orientation="horizontal" />
                                    <ChartCategoryAxis>
                                        <ChartCategoryAxisItem categories={categories || []} startAngle={45} />
                                    </ChartCategoryAxis>
                                    <ChartValueAxis>
                                        <ChartValueAxisItem title={{ text: productYAxis }} />
                                    </ChartValueAxis>
                                    <ChartSeriesDefaults type="column" overlay={{ gradient: "sharpBevel" }} gap={0.3} spacing={0.2} />
                                    <ChartSeries>
                                        {(productPerformance || []).map((item, idx) => (
                                            <ChartSeriesItem key={idx} data={item.data} name={item.name} />
                                        ))}
                                    </ChartSeries>
                                </Chart>
                            )}
                        </DashboardChartCard>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6 mb-4">
                        <DashboardChartCard title="Accumulated Total" icon="fa-arrow-trend-up" subtitle="Cumulative performance comparison" actions={<ButtonsGroup
                            exportName="total"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("total")}
                        />}>
                            {showSkeleton ? <DashboardChartSkeleton /> : (
                                <Chart {...DASHBOARD_CHART_OPTIONS} ref={totalRef} style={{ height: 245 }}>
                                    <ChartLegend position="top" orientation="horizontal" />
                                    <ChartCategoryAxis>
                                        <ChartCategoryAxisItem categories={labels || []} startAngle={45} />
                                    </ChartCategoryAxis>
                                    <ChartValueAxis>
                                        <ChartValueAxisItem title={{ text: accYAxis }} />
                                    </ChartValueAxis>
                                    <ChartSeriesDefaults type="area" overlay={{ gradient: "sharpBevel" }} />
                                    <ChartSeries>
                                        {(accumulated || []).map((item, idx) => (
                                            <ChartSeriesItem key={idx} data={item.data} name={item.name} />
                                        ))}
                                    </ChartSeries>
                                </Chart>
                            )}
                        </DashboardChartCard>
                    </div>

                    <div className="col-6 mb-4">
                        <DashboardChartCard title={siteHeading} icon="fa-location-dot" subtitle="Performance breakdown" actions={<ButtonsGroup
                            exportName="site"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("site")}
                        />}>
                            {showSkeleton ? <DashboardChartSkeleton /> : (
                                <Chart {...DASHBOARD_CHART_OPTIONS} ref={siteRef} style={{ height: 245 }}>
                                    <ChartLegend position="top" orientation="horizontal" />
                                    <ChartSeries>
                                        <ChartSeriesItem type="pie" overlay={{ gradient: "sharpBevel" }} tooltip={{ visible: true }} data={pieData || []} categoryField="name" field="share" />
                                    </ChartSeries>
                                </Chart>
                            )}
                        </DashboardChartCard>
                    </div>
                </div>
            </>
        );
    }, [isLoading, sales, title, labels, salesYAxis, productPerformance, categories, productYAxis, accumulated, accYAxis, pieData, siteHeading, onImageExportClick]);

    return (
        <>
            <ExpansionPanel
                className="wm-advanced-search wm-advanced-search--kendo wm-dashboard-advanced-search"
                title="Advanced Search"
                expandIcon="fa fa-plus"
                collapseIcon="fa fa-minus"
                expanded={expanded}
                onAction={(event) => setExpanded(!event.expanded)}
            >
                <Reveal>
                    {expanded && (
                        <ExpansionPanelContent>
                            <div className="wm-advanced-search__fields">
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceLoadType">Load Type</label>
                                    <MultiSelect id="PerformanceLoadType" data={loadTypes} value={loadType} onChange={changeHandlers.loadType} placeholder="Select load type" filterable />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceVehicleType">Vehicle Type</label>
                                    <MultiSelect id="PerformanceVehicleType" data={vehicleTypes} value={vehicleType} onChange={changeHandlers.vehicleType} placeholder="Select vehicle type" filterable textField="name" dataItemKey="id" />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceJob">Job</label>
                                    <MultiSelect id="PerformanceJob" data={jobdata} value={job} onFilterChange={filterjobChange} onChange={changeHandlers.job} placeholder="Select job" filterable textField="name" dataItemKey="id" />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceCustomer">Customer</label>
                                    <MultiSelect id="PerformanceCustomer" data={customerdata} value={customer} onFilterChange={filtercustChange} onChange={changeHandlers.customer} placeholder="Select customer" filterable textField="name" dataItemKey="id" />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceSource">Source</label>
                                    <MultiSelect id="PerformanceSource" data={srcdata} value={source} onFilterChange={filtersrcChange} onChange={changeHandlers.source} placeholder="Select source" filterable textField="name" dataItemKey="id" />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceDestination">Destination</label>
                                    <MultiSelect id="PerformanceDestination" data={destdata} value={destination} onFilterChange={filterdestChange} onChange={changeHandlers.destination} placeholder="Select destination" filterable textField="name" dataItemKey="id" />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceSite">Site</label>
                                    <MultiSelect id="PerformanceSite" data={sites} value={site} onChange={changeHandlers.site} placeholder="Select site" filterable textField="name" dataItemKey="id" />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceProduct">Product</label>
                                    <MultiSelect id="PerformanceProduct" data={productdata} value={product} onFilterChange={filterprodChange} onChange={changeHandlers.product} placeholder="Select product" filterable textField="name" dataItemKey="id" />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="PerformanceDirection">Direction</label>
                                    <MultiSelect id="PerformanceDirection" data={directions} value={direction} onChange={changeHandlers.direction} placeholder="Select direction" filterable />
                                </div>
                                <div className="wm-advanced-search__field wm-advanced-search__date">
                                    <DateRangePicker id="PerformanceDateRange" value={dateRange} format="dd/MM/yyyy" onChange={DateRangeChanged} startDateInputSettings={{ ariaLabel: "Date - Start" }} endDateInputSettings={{ ariaLabel: "Date - End" }} />
                                </div>
                                <div className="wm-advanced-search__actions">
                                    <Button onClick={DoSearch} themeColor="primary" icon="search">Apply</Button>
                                    <Button onClick={ClearSearch} icon="reset">Clear</Button>
                                </div>
                            </div>
                        </ExpansionPanelContent>
                    )}
                </Reveal>
            </ExpansionPanel>

            {dashboardCharts}

            {modalChart &&
                ReactDOM.createPortal(
                    <div
                        style={modalStyles.overlay}
                        onClick={() => setModalChart(null)}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
                            <button
                                style={modalStyles.closeBtnTopRight}
                                aria-label="Close zoom modal"
                                onClick={() => setModalChart(null)}
                            >
                                &times;
                            </button>
                            {renderModalChart()}
                            <button style={modalStyles.closeBtnBottom} onClick={() => setModalChart(null)}>
                                Close
                            </button>
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
};

export default PerformanceTrend;




